import React, { useCallback, useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import {
  developerIdTokenState,
  originalPathState,
  userInfoState,
} from "../global-state";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import LoadingSpinner from "../common/loading";
import ScriptEditView from "../automation/script-edit-view";
import AutomationHistoryList from "../automation/automation-history-list";
import AutomationHistoryStatistics from "../menu/automation-history-statistics";
import AutomationStatistics from "../menu/automation-statistics";
import OverviewConfigView from "../automation/overview-config-view";
import AutomationListView from "../automation/automation-list-view";
import AutomationTwinListView from "../automation/automation-twin-list-view";
import PremadeGalleryView from "../premade/premade-gallery-view";
import PremadeScriptView from "../premade/premade-script-view";
import SettingView from "../setting/setting-view";
import NotificationDialogSystem from "./notification-dialog-system";
import DashboardView from "../dashboard/dashboard-view";
import CanvasManage from "../dashboard/canvas-manage";
import TaskFlowListView from "../taskflow/task-flow-list-view";
import { useBackdrop } from "../common/backdrop";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import GridOnIcon from "@mui/icons-material/GridOn";
import GridOffIcon from "@mui/icons-material/GridOff";
import SettingsIcon from "@mui/icons-material/Settings";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AppBar from "@mui/material/AppBar";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import AutomationDebugView from "../automation/automation-debug-view";
import ChatView from "../chat/chat-view";
import { Bot } from "lucide-react";
import AddIcon from "@mui/icons-material/Add";
import { useAuth } from "../auth/auth-provider";
import IntegrationListView from "../integration/integration-list-view";
import Menu from "../menu/menu";
import Scope from "../menu/scope";
import IntegrationDetailView from "../integration/integration-detail-view";
import { Fab, useMediaQuery, Button, Badge } from "@mui/material";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import MenuIcon from "@mui/icons-material/Menu";
import SchedulesListView from "../menu/schedule";
import TaskFlowTempView from "../taskflow/task-flow-temp-view";
import PhoneSetting from "../menu/phone-setting";
import HubSetting from "../menu/hub-setting";
import { useEventEmitter } from "../ws/event-context";
import { DragDropProvider } from "../dashboard/drag-context";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { matchPath } from "react-router-dom";

const UserApp = ({ history }) => {
  const [originalPath, setOriginalPath] = useRecoilState(originalPathState);
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const [developerIdToken, setDeveloperIdToken] = useRecoilState(
    developerIdTokenState
  );
  const [notificationStatus, setNotificationStatus] = useState(0);
  const [showReloadButton, setShowReloadButton] = useState(false);
  const path = useLocation();
  const { openBackdrop, closeBackdrop } = useBackdrop();
  const theme = useTheme();
  const location = useLocation();
  const [addWidget, setAddWidget] = useState(false);
  const [drag, setDrag] = useState(false);
  const { userAuthState, setUserAuthState } = useAuth();
  const [showFilter, setShowFilter] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const [openAppbar, setOpenAppbar] = useState(true);
  const { emit } = useEventEmitter();

  const [notificationListOpen, setNotificationListOpen] = React.useState(false);

  const handleDrag = useCallback(() => {
    setDrag((prevDrag) => !prevDrag);
  }, []);

  const handleAdd = () => {
    if (currentRoute.path === "/automation/list") {
      history.push(`/automation/overview?mode=new`);
    } else if (currentRoute.path === "/taskflow/list") {
      history.push(`/automation/overview?mode=new`);
    } else if (currentRoute.path === "/premade/gallery") {
      history.push(`/premade/script`);
    } else if (currentRoute.path === "/dashboard") {
      emit("_dashboard_", { command: "add" });
    }
  };

  const devPath = [
    "/automation/script",
    "/automation/debug",
    "/premade/script",
  ];

  const routes = [
    {
      path: "/dashboard",
      exact: true,
      component: DashboardView,
      title: "Dashboard",
      showAdd: true,
      showBack: false,
      showDrag: true,
      showNav: true,
      showMenu: true,
      showNotification: true,
      props: { drag, dragClose: handleDrag },
    },
    {
      path: "/dashboard/manage",
      exact: true,
      component: CanvasManage,
      title: "Canvas Manage",
      showBack: true,
      showDrag: false,
      showNav: false,
    },
    {
      path: "/chat",
      exact: true,
      component: ChatView,
      title: "Assistant",
      showAdd: false,
      showBack: true,
      props: {},
      backPath: "/dashboard",
    },
    {
      path: "/automation/script",
      exact: true,
      title: "Automation Script",
      showAdd: false,
      showBack: true,
      component: ScriptEditView,
      backPath: "/automation/list",
    },
    {
      path: "/automation/debug",
      exact: true,
      title: "Automation Debug",
      showAdd: false,
      showBack: true,
      component: AutomationDebugView,
      backPath: "/automation/list",
    },
    {
      path: "/automation/history",
      exact: true,
      title: "Automation History",

      showAdd: false,
      showBack: true,
      component: AutomationHistoryList,
      backPath: "/automation/history",
    },
    {
      path: "/automation/history/statistics",
      exact: true,
      title: "History Statistics",

      showAdd: false,
      showBack: true,
      component: AutomationHistoryStatistics,
      backPath: "/automation/history",
    },
    {
      path: "/automation/overview",
      exact: true,
      title: "Automation",

      showAdd: false,
      showBack: true,
      component: OverviewConfigView,
      backPath: "/automation/list",
    },
    {
      path: "/automation/list",
      exact: true,
      title: "Recurring Automation",
      showAdd: true,
      showBack: false,
      showNotification: true,
      showNav: true,
      component: AutomationListView,
      props: { showFilter: showFilter, setShowFilter: setShowFilter },
    },
    {
      path: "/automation/twin/list",
      exact: true,
      title: "Card Automation",
      showAdd: false,
      showBack: true,
      showNotification: false,
      showNav: false,
      component: AutomationTwinListView,
      backPath: "/dashboard",
    },
    {
      path: "/premade/gallery",
      exact: true,
      title: "Premade Automation",

      showAdd: true,
      showBack: false,
      showNotification: true,
      showNav: true,
      component: PremadeGalleryView,
      props: {
        showFilter: showFilter,
        setShowFilter: setShowFilter,
      },
    },
    {
      path: "/premade/script",
      exact: true,
      title: "Premade Automation",

      showAdd: false,
      showBack: true,
      component: PremadeScriptView,
      backPath: "/premade/gallery",
    },
    {
      path: "/setting",
      exact: true,
      title: "Setting",

      showAdd: false,
      showBack: true,
      component: SettingView,
      backPath: "/menu",
    },
    {
      path: "/taskflow/list",
      exact: true,
      title: "TaskFlow Automation",

      showAdd: true,
      showBack: false,
      showNotification: true,
      showNav: true,
      component: TaskFlowListView,
      props: { showFilter: showFilter, setShowFilter: setShowFilter },
    },

    {
      path: "/commandtrack/list",
      exact: true,
      title: "Command Track",
      showBack: true,
      component: TaskFlowTempView,
      backPath: "/menu",
    },
    {
      path: "/menu",
      exact: true,
      title: "Menu",

      showAdd: false,
      showBack: false,
      showNotification: true,
      showNav: true,
      component: Menu,
      props: { showFilter: showFilter, setShowFilter: setShowFilter },
    },
    {
      path: "/space",
      exact: true,
      title: "Space",

      showAdd: false,
      showBack: true,
      component: Scope,
      backPath: "/menu",
    },
    {
      path: "/automation/statistics",
      exact: true,
      title: "Automation Statistics",

      showAdd: false,
      showBack: true,
      component: AutomationStatistics,
      backPath: "/menu",
    },
    {
      path: "/integerations",
      exact: true,
      title: "Integerations",

      showAdd: false,
      showBack: true,
      showNotification: true,
      component: IntegrationListView,
      props: { showFilter: showFilter, setShowFilter: setShowFilter },
      backPath: "/menu",
    },
    {
      path: "/integration",
      exact: true,
      title: "Integration",

      showAdd: false,
      showBack: true,
      component: IntegrationDetailView,
      backPath: "/integerations",
      props: { showFilter: showFilter, setShowFilter: setShowFilter },
    },
    {
      path: "/schedules",
      exact: true,
      title: "Schedule",

      showAdd: false,
      showBack: true,
      component: SchedulesListView,
      backPath: "/menu",
    },
    {
      path: "/phone/setting",
      exact: true,
      title: "Phone Setting",

      showAdd: false,
      showBack: true,
      component: PhoneSetting,
      backPath: "/menu",
    },
    {
      path: "/hub/setting",
      exact: true,
      title: "Hub Setting",
      showAdd: false,
      showBack: true,
      component: HubSetting,
      backPath: "/menu",
    },
    {
      path: "/notifications",
      exact: true,
      title: "Notifications",
      showAdd: false,
      showBack: true,
      component: NotificationDialogSystem,
      backPath: "/dashboard",
      props: {
        listOpen: notificationListOpen,
        setListOpen: setNotificationListOpen,
        setNotificationStatus: setNotificationStatus,
      },
    },
  ];

  useEffect(() => {
    if (location.pathname === "/setting" && location.hash && isSmallScreen) {
      setOpenAppbar(false);
    } else {
      setOpenAppbar(true);
    }
  }, [location, isSmallScreen, setOpenAppbar]);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (
        action === "POP" &&
        location.pathname !== "/notifications" &&
        notificationListOpen
      ) {
        setNotificationListOpen(false);
      }
    });

    return () => {
      unlisten();
    };
  }, [history, notificationListOpen]);

  useEffect(() => {
    if (location.pathname === "/notifications" && isSmallScreen) {
      setNotificationListOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (notificationListOpen) {
      if (location.pathname !== "/notifications" && isSmallScreen) {
        history.push("/notifications");
      } else if (location.pathname === "/notifications" && !isSmallScreen) {
        if (history.length > 1) {
          history.goBack();
        } else {
          history.replace(currentRoute.backPath);
        }
      }
    }
  }, [location.pathname, isSmallScreen, notificationListOpen]);

  useEffect(() => {
    if (!userAuthState) {
      const timer = setTimeout(() => {
        setShowReloadButton(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [userAuthState]);

  const getCurrentRoute = () => {
    let r;
    try {
      r = routes.find((route) =>
        matchPath(path.pathname, { path: route.path, exact: !!route.exact })
      );
      if (!r) {
        r = routes[0];
      }
    } catch (error) {
      r = routes[0];
    }

    if (r.path === "/integration") {
      r = {
        ...r,
        hash: location.hash,
      };
    }

    return r;
  };

  const currentRoute = getCurrentRoute();

  useEffect(() => {
    if (!history) {
      return;
    }
    setOriginalPath(path.pathname + path.search);
    setCurTab(getCurrentTab());
  }, [history]);

  const handleNotificationIconClick = () => {
    if (isSmallScreen) {
      setNotificationListOpen(!notificationListOpen);
      history.push("/notifications");
    } else {
      setNotificationListOpen(!notificationListOpen);
    }
  };

  const getCurrentTitle = () => {
    return currentRoute ? currentRoute.title : "";
  };

  const [curTab, setCurTab] = React.useState(-1);

  const getCurrentTab = () => {
    if (location.pathname === "/dashboard") return 0;
    if (location.pathname === "/automation/list") return 1;
    if (location.pathname === "/taskflow/list") return 2;
    if (location.pathname === "/premade/gallery") return 3;
    if (location.pathname === "/menu") return 4;
    return 0;
  };

  const handleSettingsClick = () => {
    history.push("/setting");
  };

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        bgcolor: theme.palette.background.default,
      }}
    >
      {!userAuthState ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <LoadingSpinner />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              width: "100%",
              paddingBottom: currentRoute.showNav ? "74px" : "10px",
            }}
          >
            {openAppbar && (
              <AppBar
                position="fixed"
                sx={{
                  backgroundColor: theme.palette.background.default,
                  backgroundImage: "none",
                  border: "none",
                  boxShadow: "none",
                }}
              >
                <Toolbar>
                  <>
                    {currentRoute && currentRoute.showBack && (
                      <IconButton
                        color="inherit"
                        aria-label="overview"
                        edge="start"
                        sx={{ mr: 2 }}
                        onClick={() => {
                          if (location.pathname === "/notifications") {
                            setNotificationListOpen(false);
                          }
                          if (history.length > 1) {
                            if (location.pathname.startsWith("/setting")) {
                              history.push("/menu");
                            } else {
                              history.goBack();
                            }
                          } else {
                            history.replace(currentRoute.backPath);
                          }
                        }}
                      >
                        <ArrowBackIcon
                          sx={{
                            color: "text.primary",
                          }}
                        />
                      </IconButton>
                    )}
                    <Typography
                      variant="h6"
                      component="div"
                      noWrap
                      sx={{
                        flexGrow: 1,
                        color: "text.primary",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {getCurrentTitle()}
                    </Typography>
                    {(currentRoute.path === "/premade/gallery" ||
                      currentRoute.path === "/automation/list" ||
                      currentRoute.path === "/taskflow/list" ||
                      currentRoute.path === "/menu/integrations" ||
                      (currentRoute.path === "/integration" &&
                        currentRoute.hash !== "#info")) && (
                      <IconButton
                        color="inherit"
                        aria-label="filter"
                        onClick={() => {
                          if (showFilter) {
                            if (
                              location.pathname.startsWith("/taskflow/list")
                            ) {
                              localStorage.removeItem("filterParams-taskflow");
                            } else if (
                              location.pathname.startsWith("/automation/list")
                            ) {
                              localStorage.removeItem("filterParams-recurring");
                            }
                          }
                          setShowFilter(!showFilter);
                        }}
                      >
                        <FilterListIcon
                          sx={{
                            color: showFilter
                              ? theme.palette.text.warning
                              : "text.primary",
                          }}
                        />
                      </IconButton>
                    )}

                    {currentRoute && currentRoute.showMenu && (
                      <IconButton
                        aria-label="menu"
                        onClick={() => {
                          history.push("/dashboard/manage");
                        }}
                      >
                        <DashboardCustomizeIcon
                          sx={{
                            color: "text.primary",
                          }}
                        />
                      </IconButton>
                    )}

                    {currentRoute && currentRoute.showDrag && (
                      <IconButton
                        color={drag ? "secondary" : "inherit"}
                        aria-label="drag"
                        onClick={handleDrag}
                      >
                        {drag ? (
                          <GridOffIcon
                            sx={{
                              color: theme.palette.text.warning,
                            }}
                          />
                        ) : (
                          <GridOnIcon
                            sx={{
                              color: "text.primary",
                            }}
                          />
                        )}
                      </IconButton>
                    )}

                    {currentRoute && currentRoute.showAdd && (
                      <>
                        {path.pathname === "/premade/gallery" &&
                        !developerIdToken ? (
                          <></>
                        ) : (
                          <IconButton
                            color="inherit"
                            aria-label="add"
                            onClick={handleAdd}
                          >
                            <AddIcon
                              sx={{
                                color: "text.primary",
                              }}
                            />
                          </IconButton>
                        )}
                      </>
                    )}
                  </>

                  {currentRoute.showNotification && (
                    <IconButton
                      style={{
                        color:
                          (notificationStatus & 4) > 0
                            ? theme.palette.text.error
                            : (notificationStatus & 2) > 0
                            ? theme.palette.text.warning
                            : "text.primary",
                      }}
                      aria-label="notifications"
                      onClick={handleNotificationIconClick}
                    >
                      {(notificationStatus & 1) > 0 ? (
                        <Badge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          badgeContent={
                            <ErrorOutlineIcon
                              sx={{
                                fontSize: 12,
                                color: "white",
                                backgroundColor: "red",
                                borderRadius: "50%",
                                padding: "2px",
                              }}
                            />
                          }
                        >
                          <NotificationsIcon />
                        </Badge>
                      ) : (
                        <NotificationsIcon />
                      )}
                    </IconButton>
                  )}

                  {location.pathname === "/menu" && (
                    <IconButton
                      aria-controls="account-menu"
                      aria-haspopup="true"
                      onClick={handleSettingsClick}
                      size="large"
                      edge="end"
                      color="inherit"
                    >
                      <SettingsIcon
                        sx={{
                          color: "text.primary",
                        }}
                      />
                    </IconButton>
                  )}
                </Toolbar>
              </AppBar>
            )}

            {openAppbar && (
              <Box
                sx={(theme) => ({
                  height: {
                    xs: theme.mixins.toolbar.minHeight,
                    sm: theme.mixins.toolbar.minHeight,
                    md: theme.mixins.toolbar["@media (min-width:600px)"]
                      .minHeight,
                  },
                  flexShrink: 0,
                })}
              />
            )}
            <Box
              sx={{
                flexGrow: 1,
                backgroundColor: theme.palette.background.default,
                width: "100%",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <Switch>
                <Route
                  path="/automation/shared/:code"
                  render={({ match }) => (
                    <Redirect
                      to={`/automation/overview?sharedId=${match.params.code}`}
                    />
                  )}
                />
                {routes
                  .filter((route) => {
                    return (
                      devPath.indexOf(route.path) === -1 ||
                      userInfo.setting.engAccount
                    );
                  })
                  .map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      render={(props) => (
                        <DragDropProvider>
                          <route.component {...props} {...route.props} />
                        </DragDropProvider>
                      )}
                    />
                  ))}
                <Route path="*">
                  <Redirect to="/dashboard" />
                </Route>
              </Switch>
            </Box>
            {currentRoute && currentRoute.showNav && (
              <Paper
                sx={{
                  position: "fixed",
                  bottom: 16,
                  left: 16,
                  right: 16,
                  zIndex: 10,
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
                elevation={3}
              >
                <BottomNavigation
                  showLabels
                  value={curTab}
                  onChange={(event, newValue) => {
                    setCurTab(newValue);
                    if (newValue === 0) {
                      history.push("/dashboard");
                    } else if (newValue === 1) {
                      history.push("/automation/list");
                    } else if (newValue === 2) {
                      history.push("/taskflow/list");
                    } else if (newValue === 3) {
                      history.push("/premade/gallery");
                    } else if (newValue === 4) {
                      history.push("/menu");
                    }
                  }}
                  sx={{
                    bgcolor: theme.palette.background.white,
                    height: "48px", // Default height for BottomNavigation
                    "& .MuiBottomNavigationAction-root": {
                      minWidth: "50px",
                      padding: "4px 0",
                    },
                    "& .MuiBottomNavigationAction-label": {
                      fontSize: "8px",
                      transition: "font-size 0.2s ease", // Smooth transition
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: "18px",
                      transition: "font-size 0.2s ease", // Smooth transition
                    },
                    "& .Mui-selected": {
                      "& .MuiBottomNavigationAction-label": {
                        fontSize: "10px", // Slightly larger font size for selected label
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "22px", // Slightly larger icon size for selected icon
                      },
                    },
                  }}
                >
                  <BottomNavigationAction
                    label="Dashboard"
                    icon={<DashboardIcon />}
                  />
                  <BottomNavigationAction
                    label="Automation"
                    icon={<AutoModeIcon />}
                  />
                  <BottomNavigationAction
                    label="TaskFlow"
                    icon={<PlayCircleIcon />}
                  />
                  <BottomNavigationAction
                    label="Premade"
                    icon={<AutoAwesomeIcon />}
                  />
                  <BottomNavigationAction label="Menu" icon={<MenuIcon />} />
                </BottomNavigation>
              </Paper>
            )}
            {location.pathname !== "/notifications" && (
              <NotificationDialogSystem
                listOpen={notificationListOpen}
                setListOpen={setNotificationListOpen}
                setNotificationStatus={setNotificationStatus}
              ></NotificationDialogSystem>
            )}
          </Box>
          {currentRoute && currentRoute.showNav && (
            <Fab
              color="primary"
              size="medium"
              sx={{
                position: "fixed",
                bottom: 72, // Reduced from 88 to be closer to bottom nav bar
                right: 16,
                zIndex: 1,
                textTransform: "none",
              }}
              onClick={() => history.push("/chat")}
            >
              <Bot size={32} />
            </Fab>
          )}
        </>
      )}
    </Box>
  );
};

export default UserApp;
